/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import "./BodyLegacy.css";

export default function BodyLegacy({ bannerData }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const isDesktop = windowWidth > 991;

  const bannerBackgroundDesktop = bannerData?.bannerBackgroundDesktop || "";
  const bannerBackgroundMobile = bannerData?.bannerBackgroundMobile || "";
  const bannerBackgroundColorDesktop = bannerData?.bannerBackgroundColorDesktop || "";
  const bannerBackgroundColorMobile = bannerData?.bannerBackgroundColorMobile || "";

  const bannerBackgroundColor = isDesktop ? bannerBackgroundColorDesktop : bannerBackgroundColorMobile;
  const backgroundImage = isDesktop ? bannerBackgroundDesktop : bannerBackgroundMobile;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div
        className="banner banner-legacy"
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
          backgroundColor: bannerBackgroundColor,
        }}
      >
        {backgroundImage && (
          <img src={backgroundImage} alt="" fetchPriority="high" loading="eager" style={{ display: 'none' }} />
        )}
        <Container>
          <Row>
           
          </Row>
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <div className="bannertextdesktop">
                <p className="mastermind">{htmlParser(bannerData.mastermindbannerheading)}</p>
              </div>
              <div className="bannertextsub">
                <p>{htmlParser(bannerData.mastermindsubheading1)}</p>
              </div>
              <div className="bannertextsubpara">
                <p>{htmlParser(bannerData.mastermindsubheading2)}</p>
              </div>
            </Col>
          </Row>
          <div className="desk-explore">
            <div className="exploreandeditoin">
              <div lg={12} md={12} sm={12} xs={12}>
                <div className="editionbox">
                  <div className="edition">
                    <p className="textedition">{htmlParser(bannerData.monthedition)}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
        <div className="mobile-explore">
          <div className="exploreandeditoinmobile d-flex">
            <Col lg={12} md={12} sm={12} xs={12}>
              <div className="editionbox">
                <div className="edition">
                  <p className="textedition">{htmlParser(bannerData.montheditionmobile)}</p>
                </div>
              </div>
            </Col>
          </div>
        </div>
      </div>
    </>
  );
}
